import React, { Component } from 'react';
import Navbar from './Navbar';
import Crousel from './Crousel';
import HomeItems from './HomeItems';
import RideWithYGC from './RideWithYGC';
import Footer from './Footer';

class HomePage extends Component {
    render() {
        return (
            <div>
                <Navbar />
                <Crousel />
                <HomeItems />
                <Footer />
                
            </div>
        )
    }
}

export default HomePage
